import React, { useEffect, useState } from "react";

const SIZES = {
  md: "h-9 w-9",
  lg: "h-20 w-20",
};

// Round avatar for company logos. Logos come in any shape (often wide), so the whole
// image is fitted inside a white circle instead of being cropped by it. Falls back to
// the user placeholder icon when there is no logo or it fails to load.
export default function CompanyAvatar({ src, alt = "", size = "md", className = "" }) {
  const [failed, setFailed] = useState(false);
  const box = SIZES[size] ?? SIZES.md;

  useEffect(() => setFailed(false), [src]);

  const showImage = src && !failed;

  return (
    <span
      className={`relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full ${box}
        ring-2 ring-white shadow-[0_0_0_3px_rgb(15_23_42/0.08),0_2px_8px_-2px_rgb(15_23_42/0.18)]
        transition-shadow duration-200 hover:shadow-[0_0_0_3px_rgb(27_131_84/0.35),0_4px_12px_-2px_rgb(15_23_42/0.22)]
        dark:ring-slate-800 dark:shadow-[0_0_0_3px_rgb(255_255_255/0.12)]
        ${showImage ? "bg-white" : "bg-linear-to-br from-slate-100 to-slate-200 text-slate-400 dark:from-slate-600 dark:to-slate-700 dark:text-slate-400"}
        ${className}`}
    >
      {showImage ? (
        <img src={src} alt={alt} onError={() => setFailed(true)} className="h-full w-full object-contain p-[14%]" />
      ) : (
        // Silhouette sits low so the shoulders run off the bottom edge of the circle.
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          className="h-full w-full translate-y-[14%] scale-110"
          aria-hidden="true"
        >
          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
        </svg>
      )}
    </span>
  );
}
